module.exports = __webpack_public_path__ + "img/slide02.a3874924.jpg";